import { useTranslate } from '@va/localization';
import { SingleSelectFilter, TextFilter } from '@va/shared/feature-filters';
import { useMemo } from 'react';
import { WebsiteTrackingStatus } from '../agency-white-label-v2/agency-white-label-apiClient';

export const FILTER_NAMES = {
  trackingStatus: 'trackingStatus',
  url: 'url',
};

export const useManageWebsitesFilters = () => {
  const translate = useTranslate();

  return useMemo(() => {
    return [
      new SingleSelectFilter({
        id: '1',
        name: FILTER_NAMES.trackingStatus,
        label: translate('filters.options.trackingCodeStatus'),
        inputProps: {
          useOptions: () => ({
            data: [
              { label: translate('option.btn.active'), value: WebsiteTrackingStatus.ACTIVE },
              { label: translate('option.btn.inActive'), value: WebsiteTrackingStatus.INACTIVE },
            ],
          }),
        },
      }),
      new TextFilter({
        id: '2',
        name: FILTER_NAMES.url,
        label: translate('filters.options.searchByUrl'),
        inputProps: {
          label: translate('filter.urlName'),
        },
      }),
    ];
  }, [translate]);
};
